import { setCookie } from "../../utils/common";
import axiosInstance from "../api/axios";
import { env } from "../../utils/env";

const API_BASE_URL = env('REACT_APP_API_BASE_URL') || 'http://localhost:9000/api';

// Add console log to check API URL
console.log('Current API Base URL:', API_BASE_URL);

// Login user
export const loginUser = async (credentials) => {
  try {
    const response = await axiosInstance.post('/login', credentials);
    console.log('Login response:', response);
    return response; 
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};

export const getLoginDetails = async (username) => {
  try {
    const response = await axiosInstance.get('/login', {
      params: { username },
      
    });
    console.log('Login details response:', response);

    const userDetails = Array.isArray(response) ? response[0] : response;
    
    if (userDetails?.loginIdentifier) {
     
      setCookie('loginIdentifier', userDetails.loginIdentifier);
      console.log('loginIdentifier saved:', userDetails.loginIdentifier);
    }

    return userDetails;
  } catch (error) {
    console.error('Error getting login details:', error);
    throw error;
  }
};


export const createNewAccount = async (login_username) => {
  try {
    const response = await axiosInstance.post('/login/new-account',null, {
      params: { login_username }
    });
    console.log('New account creation response:', response);
    return response;
  } catch (error) {
    console.error('Error creating new account:', error);
    throw error;
  }
};

export const checkPassword = async (username, password) => {
    console.log("Checking password with credentials:", { username, password });
    try {
    
      const response = await axiosInstance.post('/login/check-password', {
        username,
      password
      });
      console.log('Password check response:', response);
      return response  
    } catch (error) {
      console.error('Error checking password:', error);
      throw error; 
    }
  };
  


  /**
   * GET /login/identifier-links
   * Returns every identifier link associated with the calling login.
   * Used by the customer-picker flow when a single login is wired to
   * multiple developer/customer organizations. Requires a valid bearer
   * token (the axios interceptor pulls it from the accessToken cookie).
   */
  export const fetchLoginIdentifierLinks = async () => {
    try {
      const response = await axiosInstance.get('/login/identifier-links');
      return response;
    } catch (error) {
      console.error('Error fetching login identifier links:', error);
      throw error;
    }
  };

  /**
   * POST /login/select-identifier
   * Switches the active identifier for this login and re-issues a JWT.
   * Returns the same shape as /login/check-password (ResponseLoginDetailsData)
   * — caller is responsible for swapping the token + userInfo in storage.
   */
  export const selectLoginIdentifier = async ({ linkId, remember = false }) => {
    try {
      const response = await axiosInstance.post('/login/select-identifier', {
        linkId,
        remember,
      });
      return response;
    } catch (error) {
      console.error('Error selecting login identifier:', error);
      throw error;
    }
  };

  export const setPassword = async (username, password) => {
    console.log("Setting password for user:", username);
    try {
      const response = await axiosInstance.post('/login/set-password', {
        username,
        password
      });
      console.log('Password set response:', response);
      return response;
    } catch (error) {
      console.error('Error setting password:', error);
      throw error;
    }
  };
  export const getCustomers = async ({ customerType }) => {
    try {
      const params = { customerType };
      const response = await axiosInstance.get(`/customers/subscription`, { params });
      return response;
    } catch (error) {
      console.error('Error fetching customers:', error);
      throw error;
    }
  };
  export const getCustomerEarnings = async ({ startDate, endDate }) => {
    try {
        const response = await axiosInstance.get(`/subscription/customer/earnings`, {
            params: {
               startDate,
               endDate
             },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching customer earnings", error);
        throw error;
    }
};
